import React from 'react';

/**
 * P01 · Card destacada "Empieza por lo esencial" (mockup líneas 775-788).
 * Vista para usuario NUEVO/invitado. Portada 236px con textura y badge
 * "Introductorio" arriba a la izquierda; título + meta + CTA primario 56px.
 */
export default function HomeFeatured({
  title,
  meta,
  levelLabel = 'Introductorio',
  thumbnail,
  onOpen,
  ctaLabel = 'Empezar curso',
}) {
  return (
    <article
      className="bg-surface overflow-hidden"
      style={{
        border: '1px solid var(--color-line)',
        borderRadius: 18,
        marginBottom: 30,
        boxShadow: '0 4px 18px rgba(16, 28, 54, 0.07)',
      }}
      data-slot="home-featured"
    >
      <div
        className="relative flex items-center justify-center"
        style={{
          width: '100%',
          height: 236,
          background: thumbnail
            ? undefined
            : 'repeating-linear-gradient(118deg, rgba(16,28,54,.10) 0 13px, rgba(16,28,54,.03) 13px 26px), #E3E9F2',
        }}
      >
        {thumbnail ? (
          <img
            src={thumbnail}
            alt=""
            className="w-full h-full"
            style={{ objectFit: 'cover' }}
          />
        ) : (
          <span
            style={{
              fontFamily: 'ui-monospace, monospace',
              fontSize: 11,
              color: '#3C475E',
            }}
          >
            portada del curso
          </span>
        )}
        {levelLabel && (
          <span
            style={{
              position: 'absolute',
              top: 14,
              left: 14,
              fontSize: 12,
              fontWeight: 800,
              borderRadius: 999,
              padding: '6px 12px',
              background: 'var(--color-ink)',
              color: '#fff',
            }}
          >
            {levelLabel}
          </span>
        )}
      </div>
      <div style={{ padding: '16px 16px 18px' }}>
        <h3
          style={{
            fontSize: 22,
            fontWeight: 800,
            lineHeight: 1.2,
            letterSpacing: '-.015em',
            marginBottom: 8,
            margin: 0,
          }}
        >
          {title}
        </h3>
        {meta && (
          <div
            className="text-ink-2"
            style={{ fontSize: 13.5, fontWeight: 600, marginTop: 8, marginBottom: 14 }}
          >
            {meta}
          </div>
        )}
        <button
          type="button"
          onClick={onOpen}
          className="w-full flex items-center justify-center cursor-pointer"
          style={{
            gap: 10,
            minHeight: 56,
            border: 0,
            borderRadius: 12,
            background: 'var(--color-accent)',
            color: 'var(--color-ink)',
            fontSize: 17,
            fontWeight: 800,
          }}
        >
          {ctaLabel}
        </button>
      </div>
    </article>
  );
}
